﻿<div class="form-container">

    <form class="mce-form-section"
        [style.display]="!viewState().showProjectEditForm && !viewState().showCableEditForm && !viewState().showProjectUsersForm ? 'block': 'none'">

        <div class="mce-form-section-title">Suport</div>

        <div class="mce-form-field-group">

            <div class="w-2/4">
                <mat-form-field class="w-full">
                    <mat-label>uid search string</mat-label>
                    <input matInput placeholder="uid search string"
                            [formField]="form.searchString" />

                    @for (error of form.searchString().errors(); track error.kind ) {
                    <mat-error>
                        {{ error.message }}
                    </mat-error>
                    }
                </mat-form-field>
            </div>

            <div>
                <button matButton="filled" color="primary" type="button"
                    [disabled]="!form.searchString().valid()"
                    (click)="search()">
                    <mat-icon>search</mat-icon>
                    search
                </button>
            </div>

        </div>

        @if(viewState().projectResult) {
        <div class="grid grid-cols-2 gap-4">
            <div class="max-h-[750px] min-w-0 overflow-auto">
                <pre>{{viewState().project | json}}</pre>
            </div>

            <div class="flex flex-col gap-4">

                <div class="flex gap-4">

                    <div>
                        <button matButton="filled" color="primary" type="button"
                                (click)="onEditProject()">
                            <mat-icon>edit</mat-icon>
                            edit project
                        </button>
                    </div>

                    <div>
                        <button matButton="filled" color="primary" type="button"
                                [routerLink]="['/cables', viewState().project?.uid]"
                                [disabled]="!viewState().project?.uid">
                            <mat-icon>group_work</mat-icon>
                            view cables
                        </button>
                    </div>

                    <div>
                        <button matButton="filled" color="primary" type="button"
                                (click)="onEditProjectUsers()">
                            <mat-icon>people</mat-icon>
                            manage users
                        </button>
                    </div>

                </div>


                <div class="max-h-[650px] min-w-0 overflow-auto">
                    <h2 class="mt-4 mb-2 font-medium">Cables</h2>
                    @for (cable of projectCables(); track cable) {
                    <p>
                        {{cable.designation}}: {{cable.description}}

                    <button matIconButton type="button"
                        matTooltip="Reference {{cable.uid}}. Click to copy reference to clipboard."
                        [cdkCopyToClipboard]="cable.uid ?? ''">
                    <mat-icon>chat_info</mat-icon>
            </button>
                    </p>
                    }

                </div>

            </div>






        </div>
        }

        @if(viewState().cableResult) {
            <div class="grid grid-cols-2 gap-4">
                 <div class="max-h-[750px] min-w-0 overflow-auto">
                     <pre>{{viewState().cable | json}}</pre>
                 </div>

                <div>
                    <button matButton="filled" color="primary" type="button"
                        (click)="onEditCable()">
                        <mat-icon>edit</mat-icon>
                        edit cable
                    </button>
                </div>
            </div>
        }

    </form>


    @if(viewState().noResult) {
    <div class="mce-form-field-group">
        <mce-info-message type="error">
            Searching for the given uid returned an empty result.
        </mce-info-message>
    </div>
    }

    @if (viewState().showProjectEditForm) {
    <project-edit [project]="editProject()"
                  [comments]="editProjectComments()"
                  [showDebugPanel]="true"
                  (cancelClick)="onCancelEdit()"
                  (saveClick)="onEditProjectSave($event)"></project-edit>
    }

    @if (viewState().showProjectUsersForm) {
        <project-users [project]="editProject()" (cancelClick)="onCancelEdit()"></project-users>
    }


    @if (viewState().showCableEditForm) {
    <cable-edit [cable]="editCable()"
                  [comments]="editCableComments()"
                  [showDebugPanel]="true"
                  (cancelClick)="onCancelEdit()"
                  (saveClick)="onEditCableSave($event)"></cable-edit>
    }


    @if (processing()) {
       <div class="spinner">
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
    }

</div>

                

